module.exports = __webpack_public_path__ + "static/media/Role_Icon.fb99fb4b.svg";